/**
 * Admin Sanctum Bearer token tárolás localStorage-ben (DEC-FE-013 +
 * DEC-AUTH-003).
 *
 * Külön namespace mint a publik FE (`igazirandi.bearer-token`), hogy
 * ugyanazon böngészőben mind a publik, mind az admin app egyszerre
 * használható legyen anélkül, hogy a tokenek keverednének. A backend
 * `auth:admin` és `auth:web` guard-ok különálló tokeneket adnak ki
 * (DEC-ADMIN-001).
 */
const TOKEN_KEY = 'igazirandi-admin.bearer-token'

export function getToken(): string | null {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(TOKEN_KEY)
}

export function setToken(token: string): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(TOKEN_KEY, token)
}

export function clearToken(): void {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(TOKEN_KEY)
}
